import { Region } from '../types/orderTypes';
import { ReqEnum } from '../const/requestStatus';
import Fetch from '../utils/fetch';
import { settings } from '../settings';
import { HubSortListEntry } from '../hooks/useFetchHubSortList';
import { ISortListBundle } from 'pages/NewSortList/SortListBundle';

export async function fetchHubSortListEntriesAll(
  region: Region
): Promise<[HubSortListEntry[], ReqEnum]> {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/hubsort/bundles/all?region=${region}`,
  });
  if (response.ok) {
    const hubSortListEntries = (await response.json()) as HubSortListEntry[];
    return [hubSortListEntries, ReqEnum.SUCCESS];
  } else {
    return [[], ReqEnum.ERROR];
  }
}

export type AllBundlesResponse = {
  incompletedBundles: ISortListBundle[];
  completedBundles: ISortListBundle[];
};
export async function fetchHubSortListEntriesNew(
  region: Region
): Promise<AllBundlesResponse | undefined> {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/hubsort/bundles/all2?region=${region}`,
  });
  if (response.ok) {
    return (await response.json()) as AllBundlesResponse;
  } else {
    return undefined;
  }
}
